import {Observable, Subscription} from 'rxjs';

import IMediaEventsStreamPayload from '../../../../Solutions/Shared/Interfaces/IMediaEventsStreamPayload';
import ICaptionsStore            from '../Interfaces/ICaptionsStore';

const subscribeToCueChange = (
    cueChange$: Observable<IMediaEventsStreamPayload>,
    captionsStore: ICaptionsStore
): Subscription =>
    cueChange$
        .subscribe(mediaEvent => {
            const {activeCues} = mediaEvent.state;

            if (activeCues.length < 1) {
                captionsStore.actions.hideCues();
            } else {
                captionsStore.actions.showCues(activeCues);
            }
        });

export default subscribeToCueChange;